import { useCallback, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import './login.scss';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { config } from '../../config';
import { useToast } from '../../services/ToastContext';

export const Login = () => {
  const navigate = useNavigate();
  const [sendLoading, setSendLoading] = useState(false);
  const [typePassword, setTypePassword] = useState(true);
  const [confirmTypePassword, setConfirmTypePassword] = useState(true);
  const { showToastMessage } = useToast();
  const [showPassword, setShowPassword] = useState(false);
  const [loginPage, setLoginPage] = useState<any>(true);

  const handleSubmit = useCallback(async (e: any) => {
    e.preventDefault();
    const { email, password } = e.target.elements;
    if (!email || !password) {
      showToastMessage('Invalid fields!');
      return;
    }
    setSendLoading(true);

    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };

    try {
      const response = await axios.post(
        `${config.API_URL}/op/auth/login`,
        {
          email: email.value,
          pass: password.value,
        },
        { headers: header }
      );
      setSendLoading(false);

      if (response) {
        window.localStorage.setItem('loginToken', response?.data);
        window.localStorage.setItem('email', email.value);

        const loggedUserData = await axios.get('/op/operatorId/' + email.value);

        if (loggedUserData?.data?.operatorId === 0) {
          navigate('/operators/');
          window.location.reload()
        } else {
          navigate('/operators/' + loggedUserData?.data?.operatorId);
          window.location.reload()

        }
      }
    } catch (e: any) {
      console.log(e);
      setSendLoading(false);
      showToastMessage(String(typeof e?.response?.data === 'string' ? e.response.data : e.message));
      //toastRef.current.toggleShow(StringUtils.formatErrorMsg(e.message), true);
    }
  }, []);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleSubmitRegister = useCallback(async (e: any) => {
    e.preventDefault();

    const { email, password, confirmPassword } = e.target.elements;

    if (!email.value || !password.value || !confirmPassword.value) {
      //toastRef.current.toggleShow('Invalid fields!');
      showToastMessage('Invalid fields!');
      return;
    }

    if (password.value !== confirmPassword.value) {
      showToastMessage('Password does not match!');
      return;
    }

    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };

    try {
      //const uc: UserCredential = await signInWithEmailAndPassword(auth, email.value, password.value)
      const response = await axios.post(
        `${config.API_URL}/op/auth/register`,
        {
          email: email.value,
          pass: password.value,
          confirmPass: confirmPassword.value,
        },
        { headers: header }
      );
      console.log(response);

      if (response) {
        showToastMessage('User created successfully!');
        setTimeout(() => {
          setLoginPage(true)
            ;
        }, 100);
      }
    } catch (e: any) {
      showToastMessage(e.message, true);
    }
  }, []);

  //TODO convert to react bootstrap form
  return (
    <div id="Login" className="flex">
      <section>
        <img alt="Main Icon" className="main-logo" src="/images/sidebar_login.png" />
      </section>
      <section className="flex flex-col items-center justify-center grow">
        {loginPage && (
          <div>
            <header className="flex flex-col gap-2 mb-10">
              <span className="text-5xl font-extrabold">Login</span>
              <span className="" style={{ color: '#A6BCCC' }}>
                Enter your email and password to login.
              </span>
            </header>
            <form className="fields-panel" onSubmit={handleSubmit}>
              <div className="mb-2">
                <label style={{ color: '#5A7283' }} className="text-sm mb-1">
                  Email
                </label>
                <input className="input-login" name="email" placeholder="user@mail.com" type="email" />
              </div>

              <div>
                <label style={{ color: '#5A7283' }} className="text-sm mb-1">
                  Password
                </label>
                <input className="input-login pwd" name="password" type={showPassword ? "text" : "password"} placeholder="Password" />
                <span onClick={togglePasswordVisibility} className="cursor-pointer eyeslash">
                  {showPassword ? (
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {/* Eye icon for showing password */}
                      <path d="M1 12.2056C1 12.2056 5 4.20557 12 4.20557C19 4.20557 23 12.2056 23 12.2056C23 12.2056 19 20.2056 12 20.2056C5 20.2056 1 12.2056 1 12.2056Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M12 15.2056C13.6569 15.2056 15 13.8624 15 12.2056C15 10.5487 13.6569 9.20557 12 9.20557C10.3431 9.20557 9 10.5487 9 12.2056C9 13.8624 10.3431 15.2056 12 15.2056Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  ) : (
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {/* Eye slash icon for hiding password */}
                      <g clipPath="url(#clip0_1958_5399)">
                        <path d="M1.20264 12.8623C1.20264 12.8623 5.20264 4.8623 12.2026 4.8623C19.2026 4.8623 23.2026 12.8623 23.2026 12.8623C23.2026 12.8623 19.2026 20.8623 12.2026 20.8623C5.20264 20.8623 1.20264 12.8623 1.20264 12.8623Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12.2026 15.8623C13.8595 15.8623 15.2026 14.5192 15.2026 12.8623C15.2026 11.2055 13.8595 9.8623 12.2026 9.8623C10.5458 9.8623 9.20264 11.2055 9.20264 12.8623C9.20264 14.5192 10.5458 15.8623 12.2026 15.8623Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M22.2026 2.8623L2.20264 22.8623" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1958_5399">
                          <rect width="24" height="24" fill="white" transform="translate(0.202637 0.862305)" />
                        </clipPath>
                      </defs>
                    </svg>
                  )}
                </span>
              </div>
              <div className="flex items-center mt-2 justify-between">
                <div className="flex">
                  <input
                    type="checkbox"
                    id="remember_me"
                    name="remember_me"
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded "
                  // checked={false}
                  // checked={rememberMe}
                  // onChange={handleRememberMeChange}
                  />
                  <label htmlFor="remember_me" className="ml-2 block text-sm text-gray-900">
                    Remember Me
                  </label>
                </div>

                <div>
                  <p className="m-0">
                    <a
                      href="/forgot-password"
                      className="text-sm font-medium leading-none justify-center peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-textForeground cursor-pointer hover:underline"
                    >
                      Forgot Password?
                    </a>
                  </p>
                </div>
              </div>
              <Button className="main-btn" type="submit">
                {!sendLoading && <span className="indicator-label text-sm">Login</span>}
                {!!sendLoading && (
                  <span className="indicator-progress" style={{ display: 'block' }}>
                    Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </Button>

              <div className="flex gap-1 text-sm mt-3">
                <span>Not Registered?</span>
                <span
                  tabIndex={0}
                  className="cursor-pointer font-medium"
                  style={{ color: '#35B888', fontFamily: 'Inter' }}
                  onClick={() => setLoginPage(false)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      setLoginPage(false);
                    }
                  }}
                >
                  Create an Account.
                </span>
              </div>
            </form>
          </div>
        )}

        {/*  {loginPage && (
          <Button className="main-btn signup-btn" onClick={() => setLoginPage(false)}>
            Create Account
          </Button>
        )} */}

        {!loginPage && (
          <div>
            <header className="flex flex-col gap-2 mb-10">
              <span className="text-5xl font-extrabold">Sign Up</span>
              <span
                className="font-sem
              
              ibold"
                style={{ color: '#A6BCCC' }}
              >
                Enter your email and password to sign up.
              </span>
            </header>
            <form className="fields-panel" onSubmit={handleSubmitRegister}>
              <div className="mb-2">
                <label style={{ color: '#33414A' }} className="text-sm mb-1">
                  Email
                </label>
                <input className="input-login" name="email" placeholder="user@mail.com" type="email" />
              </div>

              <div className="mb-2">
                <label style={{ color: '#33414A' }} className="text-sm mb-1">
                  Password
                </label>

                <div className="relative">
                  <input className="input-login" name="password" placeholder="Password" type={typePassword ? 'password' : 'text'} />
                  {/* <img
                    style={{ top: '10px' }}
                    onClick={() => setTypePassword(!typePassword)}
                    className="absolute right-3 scale-90 cursor-pointer"
                    src="/icons/eye-login.svg"
                  ></img> */}
                  <span className="cursor-pointer eyeslash" onClick={() => setTypePassword(!typePassword)}>
                    {!typePassword ? (
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {/* Eye icon for showing password */}
                        <path d="M1 12.2056C1 12.2056 5 4.20557 12 4.20557C19 4.20557 23 12.2056 23 12.2056C23 12.2056 19 20.2056 12 20.2056C5 20.2056 1 12.2056 1 12.2056Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 15.2056C13.6569 15.2056 15 13.8624 15 12.2056C15 10.5487 13.6569 9.20557 12 9.20557C10.3431 9.20557 9 10.5487 9 12.2056C9 13.8624 10.3431 15.2056 12 15.2056Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : (
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {/* Eye slash icon for hiding password */}
                        <g clipPath="url(#clip0_1958_5399)">
                          <path d="M1.20264 12.8623C1.20264 12.8623 5.20264 4.8623 12.2026 4.8623C19.2026 4.8623 23.2026 12.8623 23.2026 12.8623C23.2026 12.8623 19.2026 20.8623 12.2026 20.8623C5.20264 20.8623 1.20264 12.8623 1.20264 12.8623Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M12.2026 15.8623C13.8595 15.8623 15.2026 14.5192 15.2026 12.8623C15.2026 11.2055 13.8595 9.8623 12.2026 9.8623C10.5458 9.8623 9.20264 11.2055 9.20264 12.8623C9.20264 14.5192 10.5458 15.8623 12.2026 15.8623Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M22.2026 2.8623L2.20264 22.8623" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_1958_5399">
                            <rect width="24" height="24" fill="white" transform="translate(0.202637 0.862305)" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </span>
                </div>
              </div>

              <div>
                <label style={{ color: '#33414A' }} className="text-sm mb-1">
                  Confirm Password
                </label>

                <div className="relative">
                  <input
                    className="input-login"
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    type={confirmTypePassword ? 'password' : 'text'}
                  />
           <span className="cursor-pointer eyeslash"  onClick={() => setConfirmTypePassword(!confirmTypePassword)}>
                    {!confirmTypePassword ? (
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {/* Eye icon for showing password */}
                        <path d="M1 12.2056C1 12.2056 5 4.20557 12 4.20557C19 4.20557 23 12.2056 23 12.2056C23 12.2056 19 20.2056 12 20.2056C5 20.2056 1 12.2056 1 12.2056Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 15.2056C13.6569 15.2056 15 13.8624 15 12.2056C15 10.5487 13.6569 9.20557 12 9.20557C10.3431 9.20557 9 10.5487 9 12.2056C9 13.8624 10.3431 15.2056 12 15.2056Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : (
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {/* Eye slash icon for hiding password */}
                        <g clipPath="url(#clip0_1958_5399)">
                          <path d="M1.20264 12.8623C1.20264 12.8623 5.20264 4.8623 12.2026 4.8623C19.2026 4.8623 23.2026 12.8623 23.2026 12.8623C23.2026 12.8623 19.2026 20.8623 12.2026 20.8623C5.20264 20.8623 1.20264 12.8623 1.20264 12.8623Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M12.2026 15.8623C13.8595 15.8623 15.2026 14.5192 15.2026 12.8623C15.2026 11.2055 13.8595 9.8623 12.2026 9.8623C10.5458 9.8623 9.20264 11.2055 9.20264 12.8623C9.20264 14.5192 10.5458 15.8623 12.2026 15.8623Z" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M22.2026 2.8623L2.20264 22.8623" stroke="#C3D1DB" strokeWidth="2" strokeLinecap="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_1958_5399">
                            <rect width="24" height="24" fill="white" transform="translate(0.202637 0.862305)" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </span>
                </div>
              </div>

              <Button className="main-btn" type="submit">
                {!sendLoading && <span className="indicator-label text-sm">Submit</span>}
                {!!sendLoading && (
                  <span className="indicator-progress" style={{ display: 'block' }}>
                    Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </Button>

              <div className="flex gap-1 text-sm mt-3">
                <span>Already Registered?</span>
                <span
                  tabIndex={0}
                  className="cursor-pointer"
                  style={{ color: '#35B888' }}
                  onClick={() => setLoginPage(true)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      setLoginPage(true);
                    }
                  }}
                >
                  Login.
                </span>
              </div>
            </form>
          </div>
        )}

        {/*  {!loginPage && (
          <Button className="main-btn signup-btn" onClick={() => setLoginPage(true)}>
            Back to Login
          </Button>
        )} */}
      </section>
    </div>
  );
};
